"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = require("react");

var _reactDropzone = require("react-dropzone");

var _material = require("@mui/material");

var _utilities = require("../../utilities");

var _Typography = require("../Typography");

var _jsxRuntime = require("react/jsx-runtime");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

var StyledBox = (0, _material.styled)(_material.Box, {
  shouldForwardProp: function shouldForwardProp(prop) {
    return prop !== "disabled" && prop !== "label" && prop !== "readOnly";
  }
})(function (_ref) {
  var _hover;

  var theme = _ref.theme,
      disabled = _ref.disabled,
      label = _ref.label,
      readOnly = _ref.readOnly;
  return {
    "&:focus": {
      borderColor: theme.palette.focusRing.main,
      borderRadius: "3px",
      borderStyle: "solid",
      boxShadow: "0 2px 4px rgba(93,176,255,0.5)",
      outline: 0,
      padding: "calc(0.75rem - 2px) calc(".concat(theme.spacing(3), " - 2px)"),
      zIndex: 1
    },
    "&:hover": (_hover = {}, (0, _defineProperty2.default)(_hover, "& > .".concat(_utilities.classes.components.MuiTypography.root), {
      color: disabled ? theme.palette.brand.grey.charcoal : theme.palette.primary.main
    }), (0, _defineProperty2.default)(_hover, "background", disabled ? theme.palette.brand.grey.lightGrey : undefined), (0, _defineProperty2.default)(_hover, "borderColor", disabled ? theme.palette.brand.grey.grey : theme.palette.primary.main), (0, _defineProperty2.default)(_hover, "borderWidth", "2px"), (0, _defineProperty2.default)(_hover, "cursor", disabled && "not-allowed"), _hover),
    alignItems: "center",
    background: "white",
    border: "2px dashed",
    borderColor: theme.palette.brand.grey.stone,
    cursor: "pointer",
    display: readOnly ? "none" : "flex",
    height: theme.spacing(8),
    justifyContent: "center",
    marginTop: label ? theme.spacing(2) : undefined,
    padding: theme.spacing(3)
  };
});

var FileField = function FileField(_ref2) {
  var accept = _ref2.accept,
      children = _ref2.children,
      _ref2$disabled = _ref2.disabled,
      disabled = _ref2$disabled === void 0 ? false : _ref2$disabled,
      _ref2$error = _ref2.error,
      error = _ref2$error === void 0 ? false : _ref2$error,
      helperText = _ref2.helperText,
      label = _ref2.label,
      _ref2$margin = _ref2.margin,
      margin = _ref2$margin === void 0 ? "none" : _ref2$margin,
      maxSize = _ref2.maxSize,
      _ref2$onDrop = _ref2.onDrop,
      onDrop = _ref2$onDrop === void 0 ? function () {} : _ref2$onDrop,
      prompt = _ref2.prompt,
      _ref2$readOnly = _ref2.readOnly,
      readOnly = _ref2$readOnly === void 0 ? false : _ref2$readOnly,
      _ref2$required = _ref2.required,
      required = _ref2$required === void 0 ? false : _ref2$required;
  var helperTextId = (0, _react.useMemo)(function () {
    return (0, _utilities.generateId)();
  }, []);
  var id = (0, _react.useMemo)(function () {
    return (0, _utilities.generateId)();
  }, []);
  var onDropCallback = (0, _react.useCallback)(function () {
    if (disabled) return;
    onDrop.apply(void 0, arguments);
  }, [onDrop, disabled]);

  var _useDropzone = (0, _reactDropzone.useDropzone)({
    accept: accept,
    maxSize: maxSize,
    onDrop: onDropCallback
  }),
      getRootProps = _useDropzone.getRootProps,
      getInputProps = _useDropzone.getInputProps;

  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_material.FormControl, {
    disabled: disabled,
    error: error,
    fullWidth: true,
    margin: margin,
    required: required,
    children: [label && /*#__PURE__*/(0, _jsxRuntime.jsx)(_material.InputLabel, {
      htmlFor: id,
      shrink: true,
      children: label
    }), /*#__PURE__*/(0, _jsxRuntime.jsxs)(StyledBox, _objectSpread(_objectSpread({}, getRootProps()), {}, {
      "aria-describedby": helperTextId,
      disabled: disabled,
      label: label,
      readOnly: readOnly,
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("input", _objectSpread(_objectSpread({}, getInputProps()), {}, {
        disabled: disabled || readOnly,
        id: id
      })), /*#__PURE__*/(0, _jsxRuntime.jsx)(_Typography.Typography, {
        variant: "body2",
        children: prompt
      })]
    })), helperText && !readOnly && /*#__PURE__*/(0, _jsxRuntime.jsx)(_material.FormHelperText, {
      children: helperText,
      id: helperTextId
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_material.List, {
      children: children
    })]
  });
};

var _default = FileField;
exports.default = _default;